import { render, staticRenderFns } from "./FlyerPageRenderer.vue?vue&type=template&id=24013ff2&scoped=true"
import script from "./FlyerPageRenderer.vue?vue&type=script&lang=js"
export * from "./FlyerPageRenderer.vue?vue&type=script&lang=js"
import style0 from "./FlyerPageRenderer.vue?vue&type=style&index=0&id=24013ff2&prod&scoped=true&lang=scss"
import style1 from "./FlyerPageRenderer.vue?vue&type=style&index=1&id=24013ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24013ff2",
  null
  
)

export default component.exports